module.exports = __webpack_public_path__ + "static/media/logo-cred20min.0d6a9cdb.png";